import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FORMSI, PAGEI, THEME, WIDGET, WIDGET_CONFIG } from '../../interfaces/page-interface';
import { ActivatedRoute } from '@angular/router';
import { WebBuilderService } from '../../services/web-builder.service';
import { Subscription, interval } from 'rxjs';
import { APIConfigMapping, Charts, HTTPAPIConfig, VlDataService, VlHttpService, isNullOrUndefined } from 'shared-library';
import { WebServiceService } from '../../services/web-service.service';
import { SIDENAV_CONTENTLIST_OPTIONS, SIDENAV_DATA_MODULES } from '../../constants/side-nav.cnst';
import { WIDGET_TYPES, PAGETYPES, FROMTYPES } from '../../constants/proj.cnst';
import { IGridsterOptions, IGridsterDraggableOptions, GridsterComponent} from '@hyperviewhq/angular2gridster';
import {GridsterDropService} from '../../services/gridster-drop.service'
import { FORM } from '../../models/page_config_json';
declare const WebFont: any;

@Component({
  selector: "lib-web-screen",
  templateUrl: "./web-screen.component.html",
  styleUrls:  ["./web-screen.component.scss",'./_webTheme.scss'],
})
export class WebScreenComponent implements OnInit,AfterViewInit {
  pageData!: PAGEI;
  pageId!: string;
  gridItems: any[] = [];
  currentParams: any;
  pageDefaultFormId!: any;
  applicationId!: string;
  applicationData!: any;
  applicationTheme!: THEME;
  subscriptions: Subscription[] = [];
  isEditableSection: boolean = false;
  displayRestrictedArea!: boolean;
  widgetDropTriggered = false;
  currentlyHoveredWidget: { sectionIndex: number; widgetIndex: number } | null = null;
  containerHeight=750;
  containerWidth=1800;
  widgetTypes = WIDGET_TYPES;
  sideNavOptions = SIDENAV_DATA_MODULES;
  pageTypes = PAGETYPES;
  formTypes = FROMTYPES;
  isShowMenu: boolean = false;
  currentTime: string = "";
  selectedHeadFontFamily: string = "Roboto";
  selectedBodyFamily: string = "Roboto";
  private intervalSubscription: any;
  queryParamsData: any;
  pageNameVisible: boolean = false;
  nestedForms: any[] = [];
  isWidgetDroppedInsideForm: boolean = false;
  pageFormId: any = "";
  resizing: boolean = false;
  spinnerActive: boolean = false;
  @ViewChild(GridsterComponent, { static: true }) gridster!: GridsterComponent;
  @ViewChild('drawer') drawer:any;
  navbarStatus!:boolean;
  imageUploaderSrc :string ='../assets/images/image-placeholder.webp'
  navConfig!:any;
  menuConfig!:any;
  userInfo!:any;
  displayWidgetCharts:typeof Charts = Charts
  inDragState:boolean = false;
  selectedTheme:string = '';
  excludedPages :string[] = [this.pageTypes.splashScreen,this.pageTypes.loginPage,this.pageTypes.previewPage]
  displayOnScreenResize : boolean = true;
  showSideMenu : boolean = false;
  showAddComponent : boolean = false;
  sidenavContentOptions = SIDENAV_CONTENTLIST_OPTIONS;

  constructor(
    private route: ActivatedRoute,
    private webService: WebServiceService,
    public webBuilderService: WebBuilderService,
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private gridsterService:GridsterDropService
  ) {

  }

  static readonly X_PROPERTY_MAP: any = {
    sm: "xSm",
    md: "xMd",
    lg: "xLg",
    xl: "xXl"
  };

  static readonly Y_PROPERTY_MAP: any = {
    sm: "ySm",
    md: "yMd",
    lg: "yLg",
    xl: "yXl"
  };

  static readonly W_PROPERTY_MAP: any = {
    sm: "wSm",
    md: "wMd",
    lg: "wLg",
    xl: "wXl"
  };

  static readonly H_PROPERTY_MAP: any = {
    sm: "hSm",
    md: "hMd",
    lg: "hLg",
    xl: "hXl"
  };

  gridsterOptions: IGridsterOptions = {
    // core configuration is default one - for smallest view. It has hidden minWidth: 0.
    lanes: 12, // amount of lanes (cells) in the grid
    direction: 'none', // floating top - vertical, left - horizontal
    cellHeight:15,
    floating: true,
    dragAndDrop: true, // enable/disable drag and drop for all items in grid
    resizable: true, // enable/disable resizing by drag and drop for all items in grid
    widthHeightRatio: 1, // proportion between item width and height
    lines: {
        visible: true,
        color: '#E2E2E2',
        width: 1,

    },
    shrink: true,
    cellWidth: 15,
    useCSSTransforms: true,
    responsiveView: true, // turn on adopting items sizes on window resize and enable responsiveOptions
    responsiveDebounce: 500, // window resize debounce time
    responsiveSizes: true,
    responsiveOptions: [
        {
            breakpoint: 'sm',
            lanes: 34,
            cellWidth: 6,
            cellHeight: 12
        },
        {
            breakpoint: 'md',
            lanes: 34,
            cellWidth: 10,
            cellHeight: 20
        },
        {
            breakpoint: 'lg',
            lanes: 34,
            cellWidth: 16,
            cellHeight: 24
        },
        {
            breakpoint: 'xl',
            lanes: 34,
            cellWidth: 20,
            cellHeight: 25
            
        }
    ]
  };
  gridsterDraggableOptions: IGridsterDraggableOptions = {
      handlerClass: 'panel-heading'
  };
  itemOptions = {
        minHeight: 1,
        minWidth:2,
    };
  gridSterItems: Array<WIDGET | any> = [];
  currentScreenSize : string = 'Xl' 



  change(event:any){
    
  }

  itemChange(event:any,widgetData?: WIDGET , formData? : FORMSI, type?: string){
    let doUpdate: boolean = false;
    if(type === 'widget') {
      const widgetConfig : any = structuredClone(widgetData?.widgetConfig) as WIDGET_CONFIG;
      event.changes?.forEach( (key: string) => {
        if(event.oldValues[key]) {
          doUpdate = true;
          widgetConfig.responsiveOptions[key + event.breakpoint.charAt(0).toUpperCase() + event.breakpoint.slice(1)] = event.item[key];
          Object.keys(widgetConfig.responsiveOptions)?.forEach(async (widgetKey : string)=>{
               if(widgetKey[0] == key[0]){
                  widgetConfig.responsiveOptions[widgetKey] = event.item[key];
                 await this.updateConfig(widgetConfig.responsiveOptions)
               }
          })
        }
      })
      if(doUpdate) {
        this.webService.updateWidget({widgetConfig: widgetConfig},widgetData?.widgetId).subscribe({
          next: (data: any) => {
          },
          error: (err: any) => {},
        })
      }
    }
  }


  updateConfig(responsiveOptions : any){
    let currentHeight = responsiveOptions['h'+this.currentScreenSize]
    let currentWidth = responsiveOptions['w'+this.currentScreenSize]
    let currentX = responsiveOptions['x'+this.currentScreenSize]
    let currentY = responsiveOptions['y'+this.currentScreenSize]

    responsiveOptions['hSm'] = currentHeight;
    responsiveOptions['hMd'] = currentHeight;
    responsiveOptions['hLg'] = currentHeight;
    responsiveOptions['hXl'] = currentHeight;

    responsiveOptions['wSm'] = currentWidth;
    responsiveOptions['wMd'] = currentWidth;
    responsiveOptions['wLg'] = currentWidth;
    responsiveOptions['wXl'] = currentWidth;

    responsiveOptions['xSm'] = currentX;
    responsiveOptions['xMd'] = currentX;
    responsiveOptions['xLg'] = currentX;
    responsiveOptions['xXl'] = currentX;

    responsiveOptions['ySm'] = currentY;
    responsiveOptions['yMd'] = currentY;
    responsiveOptions['yLg'] = currentY;
    responsiveOptions['yXl'] = currentY;
  }

  itemChanged(event:any,index:number){
  }

  ngOnInit(): void {

    this.userInfo = JSON.parse(localStorage.getItem('userInfo') as string);
    this.subscribeRouterEvents();
    this.subscriberEvents();
    this.gridsterServiceSubs()
    this.getApplicationById(this.applicationId);
    this.updateTime();
    this.intervalSubscription = interval(1000).subscribe(() => {
      this.updateTime();
    });

  }


  updateGridsterResponsiveOptions() {
    this.displayOnScreenResize = false;
    const lgCellWidth = this.showSideMenu && this.showAddComponent ? 12 : (this.showSideMenu || this.showAddComponent ? 14 : 16);
    const lgCellHeight = this.showSideMenu && this.showAddComponent ? 18 : (this.showSideMenu || this.showAddComponent ? 20 : 24);
    const xlCellWidth = this.showSideMenu && this.showAddComponent ? 15 : (this.showSideMenu || this.showAddComponent ? 17 : 20);
    const xlCellHeight = this.showSideMenu && this.showAddComponent ? 22 : 25;

    this.gridsterOptions['responsiveOptions']?.forEach(item => {
      switch (item['breakpoint']) {
        case 'lg':
          item['cellWidth'] = lgCellWidth;
          item['cellHeight'] = lgCellHeight;
          break;
        case 'xl':
          item['cellWidth'] = xlCellWidth;
          item['cellHeight'] = xlCellHeight;
          break;
        default:
          break;
      }
    });
    setTimeout(() => {
      this.displayOnScreenResize = true;
    }, 50);
  }

  ngAfterViewInit(): void {
    this.webBuilderService.setSidenav(this.drawer);
  }
  


  gridsterServiceSubs(){
    const addWidgetSubscriber: any =  this.gridsterService.addedWidgetOrForm$.subscribe(( event: {widgetOrForm: WIDGET | FORMSI |  any, event: string}) => {
      this.spinnerActive = true;
       this.addWidgetOrForm(event.widgetOrForm, event.event);
    })
    this.subscriptions = this.subscriptions.concat([addWidgetSubscriber]);
  }

  subscribeRouterEvents() {
    const routerParamsSubscriber: any = this.route.queryParams.subscribe(
      async (params) => {
        this.currentParams = params;
        this.applicationId = params["id"];
        this.pageId = params["pageId"];
        if (this.pageId) {
          this.applicationTheme = this.webService.getWholeTheme();
          await this.getPageById(this.pageId);
        } else if (this.applicationData)
            this.pageData = { applicationId: this.applicationId, pageName: "" };
      }
    );
    this.subscriptions.push(routerParamsSubscriber);
  }

  subscriberEvents() {
    const pageDataSubscriber: any = this.webService.selectedPageObj$.subscribe(
      (pageData:PAGEI) => {
        if (!isNullOrUndefined(pageData)) {
          this.applyPageTheme(pageData, this.applicationTheme);
          this.pageData = pageData;
          this.menuConfig = pageData.pageConfig?.menuConfig;
          this.navConfig = pageData.pageConfig?.navConfig;
          this.pageNameVisible = true;
          this.gridSterItems = [];
          if (this.pageData.forms) {
            this.pageData.forms
              ?.find(
                (fm: any) =>
                  fm.formConfig?.formType === this.formTypes.defaultForm || true
              )
              ?.widgets?.forEach((widget: any) => {
                this.gridSterItems.push(widget);
              });
            this.nestedForms = [];
            this.pageData.forms?.forEach((fm: any) => {
              if (fm.formConfig.formType === this.formTypes.form) {
                this.nestedForms.push(fm);
              }
            });
          }
          
        } else {
          this.pageData = { applicationId: this.applicationId, pageName: "" };
        }
      }
    );

    const themesDataSubscriber: any = this.webService.themesObj.subscribe(
      (data: any) => {
        this.selectedTheme = data.themeName.split(' ').join('-');
        this.selectedHeadFontFamily = isNullOrUndefined(data?.headingFontStyle)
          ? "Roboto"
          : data?.headingFontStyle;
        this.selectedBodyFamily = isNullOrUndefined(data?.bodyFontStyle)
          ? "Roboto"
          : data?.bodyFontStyle;
        this.loadFont();
        this.applyPageTheme(this.pageData, data);
      }
    );

    const tnavStatusSubscriber: any = this.webBuilderService.mainNav$.subscribe(
      (data: any) => {
        this.navbarStatus = data;
      }
    );

    const selectedOptionSubscriber = this.webService.selectedOption$.subscribe((value) => {
      if(this.showSideMenu !== value?.isActive) {
        this.showSideMenu = value?.isActive;
        this.updateGridsterResponsiveOptions()
      }
    })

    const sidenavContentSubscribe = this.webService.sidenavContentlistSubject$.subscribe((value)=>{
      if(this.showAddComponent !== value?.isActive) {
        this.showAddComponent = value?.isActive;
        this.updateGridsterResponsiveOptions()
      }
    })

    this.subscriptions = this.subscriptions.concat([
      pageDataSubscriber,
      themesDataSubscriber,
      selectedOptionSubscriber,
      sidenavContentSubscribe
    ]);
  }

  getPageById(pageId: string): Promise<void> {
    return new Promise<void>(
      (resolve: () => void, reject: (error: any) => void) => {
        this.webService.getPageById(pageId).subscribe(
          (data: PAGEI) => {
            if (data.forms) {
              this.applyPageTheme(data, this.applicationTheme);
              this.pageData = data;
              this.gridSterItems = [];
              if (this.pageData.forms) {
                this.pageData.forms
                  ?.find(
                    (fm: any) =>
                      fm.formConfig?.formType === this.formTypes.defaultForm || true
                  )
                  ?.widgets?.forEach((widget: any) => {
                    this.gridSterItems.push(widget);
                  });
                this.nestedForms = [];
                this.pageData.forms?.forEach((fm: any) => {
                  if (fm.formConfig.formType === this.formTypes.form) {
                    this.nestedForms.push(fm);
                  }
                });
              }
              this.webService.setSelectedPage(data);
            }
            resolve();
          },
          (error: any) => {
            reject(error);
          }
        );
      }
    );
  }

  applyPageTheme(pageData: any, theme: THEME) {
    if (pageData && pageData.pageConfig && theme) {
      pageData.pageConfig.style = {
        backgroundColor: theme.defaultBackgroundColor,
      };

      pageData.forms.forEach((form: any) => {
        if (form.formConfig && form.formConfig?.style) {
          form.formConfig.style = {
            backgroundColor:
              form.formConfig.formType === this.formTypes.navBar
                ? theme.primaryColor
                : theme.secondaryColor,
          };
        }
        form.widgets.forEach((widget: any) => {
          this.applyFormWidgetStyles(widget, theme);
        });
      });
    }
  }

  applyFormWidgetStyles(widget: any, theme: THEME) {
    if (widget?.widgetConfig?.customStyleApplied) {
      return;
    }

    switch (widget?.widgetType) {
      case this.widgetTypes.textbox:
        if (widget && widget.widgetConfig.style)
          (widget.widgetConfig.style as any)["color"] = theme?.defaultTextColor;
        break;
      case this.widgetTypes.button:
        if (widget.widgetConfig && widget.widgetConfig.style) {
          (widget.widgetConfig.style as any)["backgroundColor"] =
            theme?.primaryColor;
          (widget.widgetConfig.style as any)["color"] = theme?.defaultTextColor;
        }
        break;
      case this.widgetTypes.plainText:
      case this.widgetTypes.filePicker:
      case this.widgetTypes.image:
      case this.widgetTypes.searchableDropdown:
      case this.widgetTypes.dropdown:
      case this.widgetTypes.singleselectcheckbox:
      case this.widgetTypes.radio:
      case this.widgetTypes.date:
      case this.widgetTypes.scanner:
      case this.widgetTypes.address:
      case this.widgetTypes.geotag:
        if (widget.widgetConfig && widget.widgetConfig.style)
          (widget.widgetConfig.style as any)["color"] = theme.defaultTextColor;
        break;
      case this.widgetTypes.separator:
        if (widget.widgetConfig && widget.widgetConfig.style)
          (widget.widgetConfig.style as any)["color"] = theme.primaryColor;
        break;
      default:
        break;
    }
  }

  async addWidgetOrForm(data: WIDGET | FORMSI | any, event: string)  {
    this.spinnerActive = true;
    if (event === 'addForm') {
      const formCreationResponce = await this.createForm(
        this.pageData,
        data.formConfig.formType,
        data.formConfig
      );
      let pagePostData = {
        applicationId: this.currentParams?.id,
        pageId: this.pageData.pageId,
        pageForms: this.pageData.pageConfig?.pageForms
          ? this.pageData.pageConfig?.pageForms.concat([
              formCreationResponce.formId,
            ])
          : [formCreationResponce.formId],
      };
      const updatePageResponse = await this.webBuilderService
        .updatePage(pagePostData)
        .toPromise();
      if (updatePageResponse) {
        await this.getPageById(this.pageId);
        this.spinnerActive = false;
      }
    } else {
      if (!this.isWidgetDroppedInsideForm) {
        const defaultFormData = this.pageData?.forms?.filter(
          (fm: any) => fm.formConfig?.formType === this.formTypes.defaultForm
        )?.[0];
        if (!defaultFormData) {
          const formCreationResponce = await this.createForm(
            this.pageData,
            this.formTypes.defaultForm
          );
          this.pageDefaultFormId = formCreationResponce.formId;
          let pagePostData = {
            applicationId: this.currentParams?.id,
            pageId: this.pageData.pageId,
            pageForms: this.pageData.pageConfig?.pageForms
              ? this.pageData.pageConfig?.pageForms.concat([
                  formCreationResponce.formId,
                ])
              : [formCreationResponce.formId],
          };
          const updatePageResponse = await this.webBuilderService
            .updatePage(pagePostData)
            .toPromise();
          if (updatePageResponse) {
            await this.getPageById(this.pageId);
          }
        } else {
          this.pageDefaultFormId = this.pageData?.forms
            ? defaultFormData?.formId
            : "";
        }
        const widgetResponse = await this.createWidget(data);
        const updateFormPostData = {
          applicationId: this.currentParams["id"],
          formId: this.pageDefaultFormId,
          formsWidgets: this.pageData.forms
            ? defaultFormData?.formConfig?.formsWidgets
              ? defaultFormData.formConfig?.formsWidgets?.concat(
                  widgetResponse.widgetIds
                )
              : widgetResponse.widgetIds
            : [],
        };
        const updateFormResponse = await this.webBuilderService
          .updateForm(updateFormPostData)
          .toPromise();
        if (updateFormResponse) {
          await this.getPageById(this.pageId);
          this.spinnerActive = false;
        }
      } else {
        this.isWidgetDroppedInsideForm = false;
      }
    }
  }

  createWidget(widget: any): Promise<any> {
    let widgetMeta = {
      formId: this.pageDefaultFormId,
      applicationId: this.currentParams["id"],
      widgetLabel: widget.widgetLabel ? widget.widgetLabel : widget.name,
      widgetKey: new Date().getTime()?.toString(),
      widgetType: widget.widgetType,
      widgetConfig: {
        customStyleApplied: widget?.widgetConfig?.customStyleApplied,
        placeholderText: widget?.widgetConfig?.placeholderText,
        showlabel: widget?.widgetConfig?.showlabel,
        showDeletebutton: widget?.widgetConfig?.showDeletebutton,
        style: widget?.widgetConfig?.style,
        type: widget?.widgetConfig?.type,
        validations: widget.validations,
        actions: widget?.widgetConfig?.actions,
        dimentions: widget.widgetConfig?.dimentions,
        coordinates: widget.widgetConfig?.coordinates,
        responsiveOptions: widget.widgetConfig?.responsiveOptions
      },
      masterWidgetId: widget.masterWidgetId,
      widgetDataSource: {},
    };
   widgetMeta = this.updateWidgetDataBasedOnWidgetType(widgetMeta,widget);
    return this.webBuilderService.createWidget([widgetMeta]).toPromise();
  }

  updateWidgetDataBasedOnWidgetType(widgetPostData:any,widget:WIDGET):any{
    let dataSource = {};
    if (widget.widgetType == WIDGET_TYPES.radio) {
      dataSource = {
        datasourceType: "manual",
        datasource: [
          {
            key: "",
            label: "value1",
          },
          {
            key: "",
            label: "value2",
          },
        ],
      };
    }
    widgetPostData.widgetDataSource = dataSource;
    return widgetPostData;
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  createForm(pageData: PAGEI, formType: string, formConfig?: any): Promise<any> {
    let formPostData: FORMSI = {
      applicationId: this.currentParams["id"],
      pageId: pageData.pageId,
      formLabel: formType,
      formKey: new Date().getTime()?.toString(),
      formVersion: 1,
      entityKey: "2324",
      createdBy: "user1",
      parentEntityKey: pageData.pageId,
      formConfig: {
        style: formConfig?.style ? formConfig.style : {},
        actions: {},
        formsWidgets: formConfig?.formsWidgets ? formConfig.formsWidgets : [],
        formType: formType,
        customStyleApplied: false,
        dimentions: formConfig?.dimentions,
        responsiveOptions: formConfig?.responsiveOptions
      },
    };
    return this.webService.createForm(formPostData).toPromise();
  }

  getApplicationById(id: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
      APIConfigMapping["GET_APPLICATION"]
    );
    apiConfig.postData = {
      id: id,
    };
    if (!isNullOrUndefined(this.webService.getApplicationDataEntire())) {
      this.applicationData = this.webService.getApplicationDataEntire();
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          this.webService.setApplicationDataById(data);
          this.applicationData = data;
        },
        error: (err: any) => {},
      });
    }
  }

  updateTime() {
    const time = new Date();
    this.currentTime = time.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }

  loadFont(): void {
    const selectedHeadFont = this.selectedHeadFontFamily.replace(/ /g, "+");
    const selectedBodyFont = this.selectedBodyFamily.replace(/ /g, "+");
    WebFont.load({
      google: {
        families: [
          `${selectedHeadFont}:wght@400`,
          `${selectedBodyFont}:wght@400`,
        ],
      },
    });
  }

  deleteWidget(currentPageData: PAGEI, widgetIndex: number, widget: any) {
    this.webBuilderService.deleteWidget(widget.widgetId);
    this.gridSterItems.splice(widgetIndex, 1);
    if(this.pageData.forms){
    let formIndex = this.pageData.forms?.findIndex((form:FORM) => form.formId === widget.formId);
    let widgetIndex:any = this.pageData.forms[formIndex].widgets?.findIndex((widgetItem:any) => widgetItem.widgetId === widget.widgetId);
      this.pageData.forms[formIndex].widgets?.splice(widgetIndex,1);
      this.webService.setSelectedPage(this.pageData)
    }

  }

  refreshPageData() {
    this.getPageById(this.pageId);
  }

  /**
   * method is used when widget is dropped in form
   */
  async widgetDroppedOnForm(event: DragEvent, item: any) {
    event.preventDefault();
    this.isWidgetDroppedInsideForm = true;
    let data: any = JSON.parse(event.dataTransfer!.getData("text/plain"));
    let position: any = this.setWidgetPositionInform(
      data.widgetConfig.dimentions,
      event,
      item
    );
    data.widgetConfig.dimentions.x = position.x;
    data.widgetConfig.dimentions.y = position.y;
    let widget = {
      formId: item?.formId,
      applicationId: this.currentParams["id"],
      widgetLabel: data.widgetLabel ? data.widgetLabel : data.name,
      widgetKey: new Date().getTime()?.toString(),
      widgetType: data.widgetType,
      widgetConfig: {
        customStyleApplied: data?.widgetConfig?.customStyleApplied,
        placeholderText: data?.widgetConfig?.placeholderText,
        showlabel: data?.widgetConfig?.showlabel,
        showDeletebutton: data?.widgetConfig?.showDeletebutton,
        style: data?.widgetConfig?.style,
        type: data?.widgetConfig?.type,
        validations: data.validations,
        actions: data?.widgetConfig?.actions,
        dimentions: data.widgetConfig?.dimentions,
      },
      masterWidgetId: data.masterWidgetId,
      widgetDataSource: {},
    };
    const widgetResponse = await this.webBuilderService
      .createWidget([widget])
      .toPromise();
    const updateFormPostData = {
      applicationId: this.currentParams["id"],
      formId: item.formId,
      formsWidgets: item
        ? item?.formConfig?.formsWidgets
          ? item?.formConfig?.formsWidgets?.concat(widgetResponse.widgetIds)
          : widgetResponse.widgetIds
        : [],
    };
    const updateFormResponse = await this.webBuilderService
      .updateForm(updateFormPostData)
      .toPromise();
    if (updateFormResponse) {
      await this.getPageById(this.pageId);
      this.spinnerActive = false;
    }
  }

  /**
   * method is used to set widget position when it is droped inside a form
   */
  setWidgetPositionInform(
    dimentions: any,
    eventObj: any,
    form: any,
    formType?: any
  ) {
    let initialPosition = { x: 0, y: 0 };
    let offset = { x: 0, y: 0 };
    initialPosition.x = dimentions.x;
    initialPosition.y = dimentions.y;
    let position = { ...initialPosition };
    if (formType && formType == this.formTypes.defaultForm) {
      offset.x = eventObj.offsetX;
      offset.y = eventObj.offsetY;
      position.x = offset.x;
      position.y = offset.y;
    } else {
      offset.x = eventObj.offsetX;
      offset.y = eventObj.offsetY;
      position.x = form.formConfig.dimentions.x + offset.x;
      position.y = form.formConfig.dimentions.y + offset.y;
    }
    return position;
  }

  /**
   * method is used to check if the widget position is inside a form
   */
  isObjectInsideArea(
    objectX: number,
    objectY: number,
    areaXMin: number,
    areaXMax: number,
    areaYMin: number,
    areaYMax: number
  ): boolean {
    return (
      objectX >= areaXMin &&
      objectX <= areaXMax &&
      objectY >= areaYMin &&
      objectY <= areaYMax
    );
  }

  /**
   * method is used to find when a widget is dropped in another form
   */
  checkDropedInOtherForm(
    objectX: number,
    objectY: number,
    forms: any,
    presentFormId: any
  ): any {
    for (const form of forms) {
      if (
        form.formConfig.formType === this.formTypes.form &&
        form.formId !== presentFormId
      ) {
        const formDimensions = form.formConfig?.dimentions;
        if (
          this.isObjectInsideArea(
            objectX,
            objectY,
            formDimensions.x,
            formDimensions.x + formDimensions.w,
            formDimensions.y,
            formDimensions.y + formDimensions.h
          )
        ) {
          return { exists: true, form: form };
        }
      }
    }
    return { exists: false, formId: "" };
  }

  async updateForms(
    currentForm: any,
    widget: any,
    widgetIndex: number,
    dropedForm: any
  ) {
    let postData = {
      current_formId: currentForm.formId,
      droped_formId: dropedForm.formId,
      widgetId: widget.widgetId,
      applicationId: this.applicationId,
    };
    this.webBuilderService.widgetRearrange(postData).toPromise();
  }

 
  onFormclick(form: any) {
    if (this.pageData.forms && this.pageData.pageId) {
      this.webService.setSelectedOption(this.sideNavOptions.pages, true);
      let sectionIndex = this.pageData.forms.findIndex(
        (formD: any) => formD.formId === form.formId
      );
      this.webService.setPagesExpansionPanelOpener({
        pageID: this.pageData.pageId,
        sectionIndex: sectionIndex,
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }


  getImageFile(binaryImage: any) {
    if (binaryImage == 'logo' || binaryImage == undefined) {
      return this.imageUploaderSrc;
    }else if(binaryImage.includes('mobiwise.s3')){
      return binaryImage;
    } else {
      let imageSrc = 'data:image/png;base64,';
      imageSrc = imageSrc + binaryImage;
      return imageSrc;
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize() {
    this.displayOnScreenResize = false;
    this.setCurrentScreenSize(window.innerWidth);
    setTimeout(() => {
      this.displayOnScreenResize = true;
    }, 100);
  }

  private setCurrentScreenSize(width: number) {
    if (width < 768) {
      this.currentScreenSize = 'Sm';
    } else if (width >= 768 && width < 992) {
      this.currentScreenSize = 'Md';
    } else if (width >= 992 && width < 1200) {
      this.currentScreenSize = 'Lg';
    } else {
      this.currentScreenSize = 'Xl';
    }
  }


  openNavProperties(){
    this.webService.setSelectedOption(this.sideNavOptions.pages,true);
    this.webService.setSidenavContentlistOption(this.sidenavContentOptions.nav,true);

  }

  
}
